import { object, ObjectSchema, string } from 'yup';

import { TopBarFeedbackButtonDialogFormModel } from '@/components/layout/topBar/components/feedbackButton/model/TopBarFeedbackButtonDialogForm.model.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';

export const useTopBarFeedbackButtonDialogValidation =
  (): ObjectSchema<TopBarFeedbackButtonDialogFormModel> => {
    const { t } = useTranslationWithPrefix('validation');

    return object().shape({
      description: string()
        .trim()
        .required(t('general.required'))
        .min(5, t('minLength', { min: 5 })),
      subject: string()
        .trim()
        .required(t('general.required'))
        .min(5, t('minLength', { min: 5 }))
        .max(40, t('maxLengthOfMessage', { max: 40 })),
    });
  };
